<template>
    <fieldset class="party">
<!--
        <template v-for="vCost in $v.myParty.costs.$each.$iter">
            <h3 v-text="vCost.title.$model" />
            <pre>{{ vCost.n_people }}</pre>
        </template>
-->
<!--        <pre>{{ $v }}</pre>-->

        <p v-if="costsThatSum" style="font-style: italic;">
            This event is limited to {{ max_people }} people.
            Currently, there are {{ spots_available }} spots available.
        </p>

<!--        {{ Object.values($v.myParty.costs.$each.$iter).map(vCost => vCost.$invalid) }}<br>-->
<!--        {{ Object.values($v.myParty.costs.$each.$iter).map(vCost => vCost.$error) }}<br>-->
<!--        {{ Object.values($v.myParty.costs.$each.$iter).map(vCost => vCost.n_people.$model) }}<br>-->
<!--        someCostsDirty: {{ someCostsDirty }}<br>-->
<!--        notTooFew: {{ $v.myParty.costs.notTooFew }}<br>-->
<!--        notTooMany: {{ $v.myParty.costs.notTooMany }}<br>-->

        <table v-if="costsThatSum.length" class="costs-table">
            <thead>
            <tr>
                <th
                    colspan="4"
                    v-text="'How many people are attending?'"
                />
            </tr>
            </thead>
            <tbody>

            <template
                v-for="vCost in $v.myParty.costs.$each.$iter"
            >
                <reservation-party-cost-table-row
                    v-if="vCost.$model.in_overall_total"
                    :key="vCost.id.$model"
                    :cost="vCost.$model"
                    :spots_available="spots_available"
                    :n_people="vCost.n_people.$model"
                    @input="vCost.n_people.$model = Number($event); vCost.$touch()"
                />
            </template>
            </tbody>
            <tfoot>
            <tr v-if="partySizeError">
                <th>&nbsp;</th>
                <th
                    colspan="3"
                    class="is-error"
                    style="padding-top: 5px; font-size: 100%;"
                    v-text="'Total party size must be between 1 and ' + max_people"
                />
            </tr>
            <tr v-else-if="totalIsWaitlist">
                <th>&nbsp;</th>
                <th
                    colspan="3"
                    class="is-info"
                    style="padding-top: 5px; font-size: 100%;"
                    v-text="'Not enough spots available. You will be placed on the wait list.'"
                />
            </tr>
            </tfoot>
        </table>

        <table v-if="costsThatDontSum.length" class="costs-table">
            <thead>
            <tr>
                <th
                    v-text="'Add-ons'"
                />
                <th
                    colspan="3"
                    v-text="'Quantity'"
                />
            </tr>
            </thead>
            <tbody>
            <reservation-party-cost-table-row
                v-for="cost in costsThatDontSum"
                :key="cost.id"
                :cost="cost"
                :spots_available="spots_available"
                :party-size-error="partySizeError"
                :n_people="n_people"
                @input="cost.n_people = Number($event)"
            />
            </tbody>
        </table>


<!--
        <my-radio-group
            name="waitlist_contact"
            label="Notification method"
            required
            info="We will contact you if space opens up, and we will need a prompt reply from you to confirm your interest."
            :radio-options="waitlistContactRadioOptions"
            :validator="$v.myParty.notification_method"
            :error-message="'Notification method is required.'"
            v-show="partySizeStatus === PARTY_SIZE_STATUS.WAIT_LIST"
            @change="notificationMethodChanged"
        />
-->


<!--
        n_people: {{ n_people }}<br>
        max_people: {{ max_people }}<br>
        (n_people > max_people): {{ (n_people > max_people) }}<br>
        isWaitlist: {{ isWaitlist }}<br>
        (n_people > 0): {{ (n_people > 0) }}<br>
        costIsWaitlist: {{ costIsWaitlist }}<br>
        totalIsWaitlist: {{ totalIsWaitlist }}<br>
-->

        <my-input
            label="Names in party"
            id="partyNames"
            type="textarea"
            v-model="$v.myParty.names.$model"
        />

        <my-input
            label="Notes"
            id="partyNotes"
            v-model="$v.myParty.contact_notes.$model"
            :info="notesNote"
        />
    </fieldset>
</template>

<script>
import MyInput from '../../_components/form/MyInput.vue';
import { validationMixin } from 'vuelidate';
import { required, requiredIf, minValue, maxValue, integer } from 'vuelidate/lib/validators';
import MyRadioGroup from '../../_components/form/MyRadioGroup';
import ReservationPartyCost from './Reservation-PartyCost';
import ReservationPartyCostTableRow from './Reservation-PartyCost-TableRow';
import LabelInput from '../../_components/form/LabelInput.vue';

export let PARTY_SIZE_STATUS = {
    TOO_LARGE: 1,
    WAIT_LIST: 2,
    OK: 3,
    TOO_SMALL: 4,
};

const notTooFew = (costs, vm) => {
    // console.debug('notTooFew', vm);
    return costs
        .filter(cost => cost.in_overall_total)
        .reduce((sum, cost) => sum + (Number(cost.n_people) || 0), 0) >= 1;
};

const notTooMany = function(costs) {
    // console.debug('notTooMany', this.max_people);
    const nCounted = costs
        .filter(cost => cost.in_overall_total)
        .reduce((sum, cost) => sum + (Number(cost.n_people) || 0), 0)
    ;
    // console.debug('nCounted <= max_people', nCounted, this.max_people);
    return nCounted <= this.max_people;
};

const costNotTooMany = function(cost) {
    // console.debug('costNotTooMany', cost.n_people, cost.n_max);
    // console.debug((cost.n_max === null) || ((cost.n_people ?? 0) <= cost.n_max));
    return (cost.n_max === null) || ((cost.n_people ?? 0) <= cost.n_max);
};

export default {
    components: {
        LabelInput,
        MyRadioGroup,
        MyInput,
        ReservationPartyCost,
        ReservationPartyCostTableRow,
    },

    mixins: [ validationMixin ],

    props: {
        is_visit: {
            type: Boolean,
        },
        party: {
            type: Object,
        },
        max_people: {
            type: Number,
        },
        spots_available: {
            type: Number,
        },
        costs: {
            type: Array,
        },
    },

    data() {
        return {
            myParty: Object.assign({
                costs: [],
                // n_people: null,
                names: '',
                contact_notes: '',
                notification_method: 'email',
            }, this.party),
            waitlistContactRadioOptions: [],
            PARTY_SIZE_STATUS,
        };
    },

    validations() {
        return {
            myParty: {
                costs: {
                    $each: {
                        id: {},
                        title: {},
                        n_max: {},
                        n_people: {
                            // required,
                            integer,
                            minValue: minValue(0),
                            // maxValue: maxValue(this.spots_available),
                            // maxValue: maxValue(this.max_people),
                        },
                        costNotTooMany,
                    },
                    notTooFew,
                    notTooMany,
                },
                names: {},
                contact_notes: {},
                notification_method: {
                    // required: requiredIf(function() {
                    //     return this.partySizeStatus === PARTY_SIZE_STATUS.WAIT_LIST;
                    // }),
                },
            },
        }
    },

    computed: {
        n_people() {
            // return this.myParty.costs.reduce((sum, cost) => sum + (Number(cost.n_people) || 0), 0);
            return this.myParty.costs
                .filter(cost => cost.in_overall_total)
                .reduce((sum, cost) => sum + (Number(cost.n_people) || 0), 0)
            ;
        },

        partySizeStatus() {
            if (this.n_people > this.max_people) {
                return PARTY_SIZE_STATUS.TOO_LARGE;
            } else if (this.isWaitlist) {
                return PARTY_SIZE_STATUS.WAIT_LIST;
            } else if (this.n_people <= 0) {
                return PARTY_SIZE_STATUS.TOO_SMALL;
            }
            return PARTY_SIZE_STATUS.OK;
        },

        notesNote() {
            return this.is_visit
                ? 'If you have any questions or special concerns about your visit, please contact reservations@wendellgilleymuseum.org or 207 244 7555.'
                : ''
            ;
        },

        costIsWaitlist() {
            return this.myParty.costs.some(
                cost => cost.n_max
                    && (cost.n_people > 0)
                    && (cost.n_people > (cost.n_max - cost.n_reserved))
            );
        },

        totalIsWaitlist() {
            return (this.n_people > this.spots_available);
        },

        isWaitlist() {
            return !this.partySizeError
                && !this.$v.myParty.costs.$invalid
                && (this.costIsWaitlist || this.totalIsWaitlist);
        },

        costsThatSum() {
            return this.myParty.costs.filter(cost => cost.in_overall_total);
        },

        costsThatDontSum() {
            return this.myParty.costs.filter(cost => !cost.in_overall_total);
        },

        someCostsDirty() {
            return Object.values(this.$v.myParty.costs.$each.$iter)
                .filter(vCost => vCost && vCost.$model && vCost.$model.in_overall_total)
                .some(vCost => vCost.$dirty)
            ;
        },

        partySizeError() {
            // Object.values(this.$v.myParty.costs.$each.$iter)
            //     .filter(vCost => vCost && vCost.$model && vCost.$model.in_overall_total)
            //     .forEach(vCost => { if (vCost.$model.n_people !== null) { vCost.$touch(); } })
            // ;
            //
            //
            // console.debug('partySizeError', someDirty, this.$v.myParty.costs.$anyError);
            //
            // return someDirty && this.$v.myParty.costs.$anyError;
            // return !this.$v.myParty.costs.notTooFew || !this.$v.myParty.costs.notTooMany;
            return this.someCostsDirty && (!this.$v.myParty.costs.notTooFew || !this.$v.myParty.costs.notTooMany);
        }
    },

    watch: {
        myParty: {
            deep: true,
            handler() {
                this.$emit('validity', !this.$v.myParty.$invalid);
                this.$emit('update', this.myParty);

                let partySizeStatus = PARTY_SIZE_STATUS.TOO_SMALL;
                if (this.n_people > this.max_people) {
                    partySizeStatus =  PARTY_SIZE_STATUS.TOO_LARGE;
                } else if (this.isWaitlist) {
                    partySizeStatus =  PARTY_SIZE_STATUS.WAIT_LIST;
                } else if (this.n_people > 0) {
                    partySizeStatus =  PARTY_SIZE_STATUS.OK;
                }
                this.$emit('size-status', partySizeStatus);
            },
        },
        'myParty.costs': {
            deep: true,
            handler() {
                // this.$v.myParty.costs.$touch();
            },
        },
    },

    methods: {
        // notificationMethodChanged($event) {
        //     this.myParty.notification_method = $event;
        // },

        touch() {
            this.$v.$touch();
        },
    },

    mounted() {
        this.waitlistContactRadioOptions = [
            { value: 'email', label: 'Email', checked: false },
            { value: 'sms', label: 'Text message', checked: false },
        ];
    }
}
</script>

<style lang="scss">
.reservationForm {
    th {
        text-align: left;
    }

    tfoot th {
        font-size: 11pt;
        font-weight: normal;
        line-height: 1.2;

        &.is-danger {
            color: #d8842e;
        }

        &.is-info {
            color: #1a6e74;
        }
    }

    .input.numberInput {
        width: 5em;
    }

    .costs-table {
        margin-bottom: 40px;
    }

    .party-cost-row:not(:last-child) td {
        padding-bottom: 10px;
    }
}
</style>
